module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.list), function(item, i) {
    return _c('dof-radio-item', _vm._b({
      key: i,
      attrs: {
        "config": _vm.config
      },
      on: {
        "dofRadioItemChecked": function($event) {
          _vm.dofRadioItemChecked(i, $event)
        }
      }
    }, 'dof-radio-item', item, false))
  }))
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-c40678d0!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-radio/index.vue
// module id = 661
// module chunks = 0 1